// 'any' type assertion from https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
const cssVariable = (propertyName: string, value: string | number): React.CSSProperties => ({
  [`--${propertyName}` as any]: value
});

const withBackgroundImage = (imageUrl: string): React.CSSProperties =>
  cssVariable('map-url', `url(${imageUrl})`);

const isSingleBlockDisplay = (blocks: Block[], fullHeight: boolean): boolean =>
  blocks.length === 1 && !fullHeight;

export { cssVariable, withBackgroundImage, isSingleBlockDisplay };
